import { Cache } from "memory-cache";
import { CorporationCustomsOfficeEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCorporationCustomsOfficeEntity(
  id: number
): Promise<CorporationCustomsOfficeEntity | null> {
  let entity: any = await cache.get(id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCorporationCustomsOfficeEntity(office: CorporationCustomsOfficeEntity) {
  cache.put(office.props.office_id.toString(), office, 60 * 60 * 1000 /* 1 hour */);
}
